export class Base64BlobUrl {
  dispose() {
    this.base64DataUrl = undefined;
  }
  private _blobUrl?: string;

  get blobUrl() {
    return this._blobUrl;
  }

  constructor(url?: string) {
    this.base64DataUrl = url;
  }
  set base64DataUrl(base64DataUrl: string | undefined) {
    if (this._blobUrl) {
      URL.revokeObjectURL(this._blobUrl);
      this._blobUrl = undefined;
    }

    if (base64DataUrl) {
      this._blobUrl = this.base64ToBlobUrl(base64DataUrl);
    }
  }

  private base64ToBlobUrl(base64DataUrl: string): string {
    const [contentType, base64Data] = base64DataUrl.split(';base64,');
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType.split(':')[1] });
    return URL.createObjectURL(blob);
  }
}
